import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";

import FormInputError from "../General/FormInputError";

export default function TrackClaim() {
  const { t } = useTranslation();
  const trackClaimConfigurations = {
    isEnabled: false,
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const UUID = uuid();

  const claimsIdCapture = (data) => {
    navigate(`${data.claimNumber}`);
  };
  return trackClaimConfigurations.isEnabled ? (
    <>
      <div className="ui-card p-4 lg:w-10/12 lg:mx-auto xl:p-6">
        <div className="flex flex-col justify-center">
          <h2 className="text-center text-theme-text-quinary">
            {t("CustomerClaims-trackclaim-title")}
          </h2>
          <form
            onSubmit={handleSubmit(claimsIdCapture)}
            className="md:w-3/4 md:mx-auto"
          >
            <div className="mt-2 flex flex-col md:flex-row">
              <label
                className="mt-2 whitespace-nowrap mr-2"
                htmlFor={`${UUID}-claim-input`}
              >
                {t("CustomerClaims-trackclaim-claim-id")}
              </label>

              <div className="flex flex-row">
                <div className="flex flex-col mr-2">
                  <input
                    id={`${UUID}-claim-input`}
                    className=""
                    {...register("claimNumber", {
                      required: t("CustomerClaims-trackclaim-error-display"),
                    })}
                  />
                  <FormInputError errorMessage={errors?.claimNumber?.message} />
                  <div className="mt-1 text-xxs text-theme-text-tertiary">
                    {t("CustomerClaims-trackclaim-desc")}
                  </div>
                </div>
                <div>
                  <button className="ui-btn-primary h-[2.375rem]">
                    {t("Claims-trackclaim-track")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  ) : null;
}
